import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e0bc6a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "json-box"
};
const _hoisted_2 = {
  style: {
    "margin-bottom": "8px"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "json-display"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "{", -1));
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "json-complex-value"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "}", -1));
const _hoisted_10 = {
  key: 1,
  class: "record-content"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 0,
  class: "json-display"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 变更为 ", -1));
const _hoisted_17 = {
  key: 2
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0,
  class: "json-display"
};
const _hoisted_20 = {
  key: 3
};
const _hoisted_21 = {
  key: 1,
  class: "json-display"
};
import { message } from 'ant-design-vue';
import { useRoute } from 'vue-router';
import { queryChangeRecord } from '@/api/payManage/appManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'RecordDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      default: '变更记录'
    },
    width: {
      default: 800
    },
    list: {
      default: () => []
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      skuId
    } = useRoute().query;
    const processedDataList = ref([]);
    const expandedRowKeys = ref([]);
    const loading = ref(false);
    const onExpand = (expanded, record) => {
      if (expanded) {
        expandedRowKeys.value = [record.id];
      } else {
        expandedRowKeys.value = expandedRowKeys.value.filter(key => key !== record.id);
      }
    };
    const columns = [{
      title: '变更类型',
      dataIndex: 'tag',
      key: 'tag',
      width: 300
    }, {
      title: '变更人',
      dataIndex: 'creator',
      key: 'creator',
      width: 150
    }, {
      title: '变更时间',
      dataIndex: 'createDate',
      key: 'createDate',
      width: 200
    }];
    const handleClose = () => {
      expandedRowKeys.value = [];
      emit('update:visible', false);
    };
    // 切换字段可见性
    const toggleFieldVisibility = (record, index) => {
      if (record.useList && record.useList[index]) {
        // 直接修改isHide属性
        record.useList[index].isHide = !record.useList[index].isHide;
        // 触发响应式更新
        const recordIndex = processedDataList.value.findIndex(item => item.id === record.id);
        if (recordIndex !== -1) {
          processedDataList.value[recordIndex] = {
            ...processedDataList.value[recordIndex]
          };
        }
      }
    };
    // 切换msgList中变更项的可见性
    const toggleMsgListVisibility = (record, index, field) => {
      if (!record.msgListVisibility) {
        record.msgListVisibility = {};
      }
      if (!record.msgListVisibility[index]) {
        record.msgListVisibility[index] = {};
      }
      record.msgListVisibility[index][field] = !record.msgListVisibility[index][field];
      // 触发响应式更新
      const recordIndex = processedDataList.value.findIndex(item => item.id === record.id);
      if (recordIndex !== -1) {
        processedDataList.value[recordIndex] = {
          ...processedDataList.value[recordIndex]
        };
      }
    };
    // 递归解析对象/数组结构
    const parseRecursive = (data, path = '') => {
      if (data === null || data === undefined) {
        return data;
      }
      if (typeof data === 'string') {
        // 尝试解析字符串为JSON
        try {
          const parsed = JSON.parse(data);
          if (typeof parsed === 'object' && parsed !== null) {
            return parseRecursive(parsed, path);
          }
        } catch {
          // 不是有效的JSON，保持原值
        }
        return data;
      }
      if (Array.isArray(data)) {
        return data.map((item, index) => parseRecursive(item, `${path}[${index}]`));
      }
      if (typeof data === 'object') {
        const result = {};
        for (const [key, value] of Object.entries(data)) {
          const currentPath = path ? `${path}.${key}` : key;
          result[key] = parseRecursive(value, currentPath);
        }
        return result;
      }
      return data;
    };
    const parseListData = list => {
      const processedList = list.map(item => {
        // 只处理有 diffDtoList 的数据
        if (!item.diffDtoList) {
          return item;
        }
        // ✅ 只对 JSON.parse 使用一次 try...catch
        let diffList;
        try {
          diffList = JSON.parse(item.diffDtoList);
        } catch (error) {
          console.warn(`[parseListData] JSON 解析失败，跳过该条目:`, item);
          return item; // 解析失败则返回原对象，不影响其他数据
        }
        // 递归解析整个 diffDtoList 并存入 msgList
        item.msgList = parseRecursive(diffList);
        // 只处理 tag 为 '添加' 的数据
        if (item.tag !== '添加') {
          return item;
        }
        if (!Array.isArray(diffList)) {
          console.warn(`[parseListData] diffDtoList 不是数组，跳过:`, diffList);
          return item;
        }
        // 使用递归解析后的 diffList 来生成 useList，避免重复解析
        const useList = diffList.map((diff, index) => {
          var _diff$name;
          const key = (_diff$name = diff.name) !== null && _diff$name !== void 0 ? _diff$name : `未知字段${index + 1}`;
          let value = diff.newValue !== undefined ? diff.newValue : diff.oldValue;
          // 使用递归解析函数处理单个值，避免重复的 JSON.parse 逻辑
          const parsedValue = parseRecursive(value);
          // 判断解析后的值类型
          if (parsedValue && typeof parsedValue === 'object') {
            return {
              key,
              value: parsedValue,
              type: Array.isArray(parsedValue) ? 'array' : 'object',
              isHide: true
            };
          }
          return {
            key,
            value: parsedValue,
            type: 'primitive'
          };
        });
        return {
          ...item,
          isHide: false,
          useList
        };
      });
      processedDataList.value = processedList;
    };
    const initTableData = async () => {
      loading.value = true;
      expandedRowKeys.value = [];
      processedDataList.value = [];
      if (!skuId) {
        message.warning('缺少skuId参数');
        loading.value = false;
        return;
      }
      try {
        const res = await queryChangeRecord({
          bizId: skuId,
          bizType: '商品管理',
          pageSize: 10000
        });
        // 解析数据并处理成数组形式
        parseListData(res.data);
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    watch(() => props.visible, newVal => {
      if (newVal) {
        initTableData();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: __props.visible,
        class: "record-class",
        title: __props.title,
        placement: "right",
        width: __props.width,
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_a_table, {
          columns: columns,
          "data-source": processedDataList.value,
          "expand-column-width": 100,
          pagination: {
            showSizeChanger: true,
            showTotal: total => `共 ${total} 条数据` // 展示总共有几条数据
          },
          expandRowByClick: true,
          loading: loading.value,
          "expanded-row-keys": expandedRowKeys.value,
          "row-key": record => record.id,
          onExpand: onExpand
        }, {
          expandedRowRender: _withCtx(({
            record
          }) => [record.tag === '添加' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(record.tag) + ":", 1), record.useList && record.useList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.useList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: `${record.id}-${index}`,
              class: "json-item"
            }, [item.type === 'primitive' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(`"${item.key}"`) + ": ", 1), _createElementVNode("span", null, _toDisplayString(`"${item.value}"`), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(`"${item.key}"`) + ": ", 1), _createElementVNode("span", {
              class: "complex-toggle",
              onClick: $event => toggleFieldVisibility(record, index)
            }, _toDisplayString(item.isHide ? '[点击展开]' : '[点击收起]'), 9, _hoisted_7)]), !item.isHide ? (_openBlock(), _createElementBlock("pre", _hoisted_8, _toDisplayString(typeof item.value === 'object' ? JSON.stringify(item.value, null, 2) : item.value), 1)) : _createCommentVNode("", true)]))]);
          }), 128)), _hoisted_9])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [record.msgList && record.msgList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.msgList, (value, index) => {
            var _record$msgListVisibi, _record$msgListVisibi2, _record$msgListVisibi3, _record$msgListVisibi4;
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createElementVNode("span", null, "“" + _toDisplayString(value.name) + "” 从 ", 1), typeof value.oldValue === 'object' ? (_openBlock(), _createElementBlock("span", _hoisted_12, [_createElementVNode("span", {
              class: "complex-toggle",
              onClick: $event => toggleMsgListVisibility(record, index, 'oldValue')
            }, _toDisplayString((_record$msgListVisibi = record.msgListVisibility) !== null && _record$msgListVisibi !== void 0 && (_record$msgListVisibi = _record$msgListVisibi[index]) !== null && _record$msgListVisibi !== void 0 && _record$msgListVisibi.oldValue ? '[点击收起]' : '[点击展开]'), 9, _hoisted_13), (_record$msgListVisibi2 = record.msgListVisibility) !== null && _record$msgListVisibi2 !== void 0 && (_record$msgListVisibi2 = _record$msgListVisibi2[index]) !== null && _record$msgListVisibi2 !== void 0 && _record$msgListVisibi2.oldValue ? (_openBlock(), _createElementBlock("pre", _hoisted_14, _toDisplayString(JSON.stringify(value.oldValue, null, 2)), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_15, "【" + _toDisplayString(value.oldValue) + "】", 1)), _hoisted_16, typeof value.newValue === 'object' ? (_openBlock(), _createElementBlock("span", _hoisted_17, [_createElementVNode("span", {
              class: "complex-toggle",
              onClick: $event => toggleMsgListVisibility(record, index, 'newValue')
            }, _toDisplayString((_record$msgListVisibi3 = record.msgListVisibility) !== null && _record$msgListVisibi3 !== void 0 && (_record$msgListVisibi3 = _record$msgListVisibi3[index]) !== null && _record$msgListVisibi3 !== void 0 && _record$msgListVisibi3.newValue ? '[点击收起]' : '[点击展开]'), 9, _hoisted_18), (_record$msgListVisibi4 = record.msgListVisibility) !== null && _record$msgListVisibi4 !== void 0 && (_record$msgListVisibi4 = _record$msgListVisibi4[index]) !== null && _record$msgListVisibi4 !== void 0 && _record$msgListVisibi4.newValue ? (_openBlock(), _createElementBlock("pre", _hoisted_19, _toDisplayString(JSON.stringify(value.newValue, null, 2)), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_20, "【" + _toDisplayString(value.newValue) + "】", 1))]);
          }), 128))])) : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(record.msg.replace(/ (?=【)/g, '\n')), 1))]))]),
          _: 1
        }, 8, ["data-source", "pagination", "loading", "expanded-row-keys", "row-key"])]),
        _: 1
      }, 8, ["open", "title", "width"]);
    };
  }
});